import React, { useEffect, useMemo, useState } from "react"
import { Container, UncontrolledTooltip } from "reactstrap"

import {
  getTableSortingHeaderIcon,
  handleDownload,
  toCapital,
} from "helpers/common"
import { useLazyGetTdsCerificatesQuery } from "store/api/investors/reports.api"
import downloadIcon from "../../assets/images/downloadGrey.svg"
import eye from "../../assets/images/icons/eye.svg"
import { Link } from "react-router-dom"
import TableContainer from "components/Common/TableContainer"
import { useLazyGetTdsCerificatesWpQuery } from "store/api/wealthpartnerapi/wealthReport"
import { useSelector } from "react-redux"
import Breadcrumb from "components/Common/Breadcrumb"
const defaultFilters = {
  search: "",
  page: 1,
  pageSize: 20,
  timestamp: "",
}

const certificate_period = {
  q1: `April - June`,
  q2: `July - September`,
  q3: `October - December`,
  q4: `January - March`,
}

const QuarterlyTDSCertificates = ({ type }) => {
  const [trigger] = useLazyGetTdsCerificatesQuery()
  const [triggerWp] = useLazyGetTdsCerificatesWpQuery()
  const [filters, setFilters] = useState(defaultFilters)
  const [data, setData] = useState([])
  const [count, setCount] = useState(0)
  const { userType } = useSelector((state) => state.user)
  //meta title
  document.title = `${type === "tds" ? " TDS Certificates" : "Account Statements"} | Prachay`

  const getList = async () => {
    try {
      const { data, success } =
        userType === "INVESTOR"
          ? await trigger({ type }).unwrap()
          : await triggerWp({ type }).unwrap()
      if (success) {
        setData(data.row)
        setCount(data.count)
      }
    } catch (error) {}
  }

  useEffect(() => {
    getList()
  }, [type])

  const columns = useMemo(() => {
    const headers = [
      {
        header: ({ column }) =>
          getTableSortingHeaderIcon(column, "Financial Year"),
        accessorKey: "FinancialYear",
        enableColumnFilter: false,
        enableSorting: true,
        cell: ({ row }) => <>{row.original.year}</>,
      },
      {
        header: ({ column }) =>
          getTableSortingHeaderIcon(
            column,
            type === "tds" ? "Quarter" : "Month"
          ),
        accessorKey: type === "tds" ? "Quarter" : "Month",
        enableColumnFilter: false,
        enableSorting: true,
        cell: ({ row }) => (
          <>{toCapital(row.original[type === "tds" ? "quarter" : "month"])}</>
        ),
      },
    ]
    if (type === "tds") {
      const certificatePeriod = {
        header: ({ column }) =>
          getTableSortingHeaderIcon(column, "Certificate Period"),
        accessorKey: "CertificatePeriod",
        enableColumnFilter: false,
        enableSorting: true,
        cell: ({ row }) => {
          return <>{certificate_period[row.original.quarter]}</>
        },
      }
      headers.push(certificatePeriod)
    }

    const downloadFile = {
      header: () => <div className="">Action</div>,
      accessorKey: "DownloadLink",
      enableColumnFilter: false,
      enableSorting: true,
      cell: ({ row }) => {
        const viewTooltip = `viewTooltip-${row?.original?.id}`
        const downloadTooltip = `downloadTooltip-${row?.original?.id}`
        return (
          <>
            <div className="d-flex justify-content-center align-items-center flex-row gap-2">
              <div className="action-view">
                <Link to={row.original.file} target="_blank" id={viewTooltip}>
                  <img src={eye} alt="" />
                  <UncontrolledTooltip placement="top" target={viewTooltip}>
                    View
                  </UncontrolledTooltip>
                </Link>
              </div>
              <div className="action-view">
                <Link
                  to={"#"}
                  id={downloadTooltip}
                  onClick={() =>
                    handleDownload(
                      row.original.file,
                      `${certificate_period[row.original.quarter]}_${type === "tds" ? " TDS Certificate" : "Account Statement"}`

                      // `${type === "tds" ? " TDS Certificate" : "Account Statement"} for ${certificate_period[row.original.quarter]}`
                    )
                  }
                >
                  <img src={downloadIcon} alt="" />
                  <UncontrolledTooltip placement="top" target={downloadTooltip}>
                    Download
                  </UncontrolledTooltip>
                </Link>
              </div>
            </div>
          </>
        )
      },
    }

    headers.push(downloadFile)

    return headers
  }, [type])

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumb
            title={type === "tds" ? "TDS Certificates" : "Account Statements"}
          />

          <div className="quarterterly-tds-table-wrapper">
            <TableContainer
              filters={filters}
              setFilters={setFilters}
              count={count}
              columns={columns}
              data={data}
              buttonName={"Invite"}
              isGlobalFilter={false}
              isCustomPageSize={false}
              isPagination={false}
              pagination="pagination"
              paginationWrapper="dataTables_paginate paging_simple_numbers"
              tableClass="table-bordered   table-nowrap dt-responsive nowrap w-100 dataTable no-footer dtr-inline"
            />
          </div>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default QuarterlyTDSCertificates
